<template>
  <div>
    <my-form
      class="mobileInputBox"
      v-model="form"
      autocomplete="off"
      label-width="0"
      @submit="submitHandler"
    >
      <el-form-item
        prop="mobile"
        :rules="newRule('手机号', 'required', 'mobile')"
      >
        <el-input
          class="login-input"
          v-model="form.mobile"
          clearable
          autocomplete="off"
          :placeholder="`请输入手机号`"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="password"
        :rules="newRule('密码', 'required')"
      >
        <el-input
          class="login-input"
          show-password
          v-model="form.password"
          clearable
          autocomplete="off"
          :placeholder="`请输入密码`"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="imgCode"
        :rules="newRule('图形验证码', 'required')"

      >
        <el-input
          class="login-input"
          v-model="form.imgCode"
          clearable
          autocomplete="off"
          placeholder="请输入图形验证码">
        </el-input>
        <div v-loading="!isImageLoaded" style="position: absolute;right: 0;top: -27px;">
          <img @click="getImageSrc" :src="imageSrc" alt="图形验证码" @load="handleImageLoad"/>
        </div>
      </el-form-item>

      <template slot="btn" slot-scope="scope">
        <el-button
          type="primary"
          class="btn-login"
          @click="scope.submitHandler"
        >
          登录
        </el-button>
        <div class="info">
          还未注册，点击
          <span class="curp czhu" @click="checkHandle(true)">
              注册
            </span>
        </div>
        <div class="info">
          登录代表您已同意{{ CONFIG_PROJECT.title }}
          <span class="curp czhu" @click="getProtocol">
              服务协议和隐私政策
            </span>
        </div>
      </template>
    </my-form>
  </div>
</template>

<script>
import CONFIG_PROJECT from '@config/project';

export default {
  data() {
    return {
      form: {
        mobile: '',
        password: '',
        imgCode: '',
        uuid: ''
      },
      CONFIG_PROJECT,
      imageSrc: '',
      isImageLoaded: false
    }
  },
  methods: {
    submitHandler() {
      this.$emit('submitHandler', this.form)
    },
    getProtocol() {
      this.$emit("getProtocol")
    },
    getImageSrc() {
      this.isImageLoaded = false;
      this.$get('/web/bbs/img/captchaImage', data => {
        this.imageSrc = 'data:image/png;base64,' + data.imgVerify;
        this.form.uuid = data.uuid;
      });
    },
    handleImageLoad() {
      this.isImageLoaded = true;
    },
    checkHandle() {
      this.$emit('checkHandle', true)
    }
  },
  mounted() {
    this.getImageSrc();
  }
}
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.mobileInputBox {
  padding: 30px 20px;
}

.el-form-item--small.el-form-item {
  margin-bottom: 40px;
}

.info {
  padding-top: 10px;
}

.login-input {
  border-bottom: 1px solid #e0e4e6;

  ::v-deep {
    .el-input__inner {
      background: transparent;
      border: none;
      border-radius: 0;
      padding: 0;
    }

    .el-input-group__append {
      border: none;
      background: transparent;

      .btn-yzm {
        padding: 9px 0;
      }
    }
  }
}

.btn-login {
  width: 100%;
  font-size: 16px;
  padding: 15px;
}
</style>
